import FilterIcon from '@/assets/svg/ui-elements/list-filter.svg';
import PlusIcon from '@/assets/svg/ui-elements/plus.svg';
import SortIcon from '@/assets/svg/ui-elements/swap-vertical.svg';
import { IconButton, Typography } from '@/design-system';
import type { PipelineColumn as PipelineColumnDto } from '@/pages/pipelines/common/types';

import { getPipelineStageDisplayLabel } from './stage-presentation';
import { ColumnHeader, ColumnHeaderActions, ColumnHeaderTitle, CountBadge } from './styled';

type Props = {
  column: PipelineColumnDto;
  stageColor: string;
  stageFiltered: boolean;
  sortActive: boolean;
  onToggleStageFilter?: (_stage: string) => void;
  onToggleSort?: () => void;
  onAddCard?: (_stage: string) => void;
};

export const PipelineColumnHeader = ({
  column,
  stageColor,
  stageFiltered,
  sortActive,
  onToggleStageFilter,
  onToggleSort,
  onAddCard,
}: Props) => {
  const showFilterAction = Boolean(onToggleStageFilter);
  const showSortAction = Boolean(onToggleSort);
  const showAddAction = Boolean(onAddCard);

  return (
    <ColumnHeader>
      <ColumnHeaderTitle>
        <Typography variant="body4" fontWeight={600} color={stageColor}>
          {getPipelineStageDisplayLabel(column.label)}
        </Typography>
        <CountBadge>{column.count}</CountBadge>
      </ColumnHeaderTitle>
      {(showAddAction || showFilterAction || showSortAction) && (
        <ColumnHeaderActions>
          {showAddAction && (
            <IconButton
              color="tertiary"
              variant="ghost"
              size="xs"
              data-icon="plus"
              aria-label={`Add card to ${column.label}`}
              onClick={() => onAddCard?.(column.stage)}
            >
              <PlusIcon />
            </IconButton>
          )}
          {showFilterAction && (
            <IconButton
              color="tertiary"
              variant="ghost"
              size="xs"
              data-icon="list-filter"
              aria-pressed={stageFiltered}
              aria-label={`Filter ${column.label} cards`}
              onClick={() => onToggleStageFilter?.(column.stage)}
            >
              <FilterIcon />
            </IconButton>
          )}
          {showSortAction && (
            <IconButton
              color="tertiary"
              variant="ghost"
              size="xs"
              data-icon="swap-vertical"
              aria-pressed={sortActive}
              aria-label={`Sort ${column.label} cards`}
              onClick={() => onToggleSort?.()}
            >
              <SortIcon />
            </IconButton>
          )}
        </ColumnHeaderActions>
      )}
    </ColumnHeader>
  );
};
